import { render, staticRenderFns } from "./ProjectsOverview.vue?vue&type=template&id=bdf7057a&scoped=true"
import script from "./ProjectsOverview.vue?vue&type=script&lang=js"
export * from "./ProjectsOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf7057a",
  null
  
)

export default component.exports